import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import logoImage from "url:../assets/procareTextLogo.png";
import KILogo from "url:../assets/karolinska-institutet-logo.png";
import KIHLogo from "url:../assets/karolinska-hospita-logo.png";
import InfoButton from "../components/InfoButton";

const disclaimer =
	"The content of this website has been generated using a large language model-driven system and has not been manually reviewed on a case-by-case basis. This information is provided for exploratory purposes only and must not substitute professional medical advice.";

export default function Navbar() {
	const [isShrunk, setIsShrunk] = useState(false);

	useEffect(() => {
		const handleScroll = () => {
			setIsShrunk(window.scrollY > 40);
		};

		window.addEventListener("scroll", handleScroll);
		handleScroll();

		return () => window.removeEventListener("scroll", handleScroll);
	}, []);

	const location = useLocation();
	const navigate = useNavigate();

	const isActive = (path) => {
		if (path === "/") return location.pathname === "/";
		return location.pathname.startsWith(path);
	};

	const styles = {
		nav: {
			position: "fixed",
			top: 0,
			left: 0,
			width: "100%",
			height: isShrunk ? "30px" : "48px",
			backgroundColor: "#ffffff",
			borderBottom: "1px solid #e5e7eb",
			display: "flex",
			alignItems: "center",
			fontSize: isShrunk ? "0.72rem" : "0.85rem",
			zIndex: 1000,
			transition: "height 0.10s ease, font-size 0.10s ease, box-shadow 0.10s ease",
			boxShadow: isShrunk ? "0 2px 8px rgba(0,0,0,0.06)" : "none",
		},
		container: {
			width: "92%",
			margin: "0 auto",
			padding: isShrunk ? "0 0.75rem" : "0 1rem",
			display: "flex",
			alignItems: "center",
			justifyContent: "space-between",
			gap: "1rem",
			transition: "padding 0.22s ease",
		},
		leftLogo: {
			display: "flex",
			alignItems: "center",
			flexShrink: 0,
		},
		procareLogo: {
			height: isShrunk ? "18px" : "28px",
			width: "auto",
			display: "block",
			transition: "height 0.22s ease",
		},
		infoBlock: {
			display: "flex",
			alignItems: "center",
			gap: "10px",
		},
		right: {
			display: "flex",
			alignItems: "center",
			gap: isShrunk ? "0.75rem" : "1.2rem",
			flexShrink: 0,
			transition: "gap 0.22s ease",
		},
		link: {
			color: "#4b5563",
			textDecoration: "none",
			lineHeight: 1,
			paddingBottom: "2px",
			whiteSpace: "nowrap",
		},
		link: {
			color: "#111827",
		},
		activeLink: {
			color: "#111827",
			borderBottom: "1px solid #111827",
		},
		partnerLogos: {
			display: "flex",
			alignItems: "center",
			gap: "12px",
			flexShrink: 0,
			marginLeft: isShrunk ? "0.5rem" : "0.75rem",
		},
		partnerLogoWrapper: {
			width: isShrunk ? "60px" : "78px",
			height: isShrunk ? "18px" : "24px",
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
		},
		partnerLogo: {
			maxWidth: "100%",
			maxHeight: "100%",
			objectFit: "contain",
			display: "block",
		},
	};

	return (
		<>
			<nav style={styles.nav}>
				<div style={styles.container}>
					<div style={styles.leftLogo}>
						<Link to="/">
							<img src={logoImage} alt="PrOCaRe logo" style={styles.procareLogo} />
						</Link>
					</div>

					<div style={styles.infoBlock}>
						<InfoButton
							label="Disclaimer"
							content={disclaimer}
							className={isShrunk ? "info-button-shrunk" : "info-trigger-button"}
						/>

						<button
							type="button"
							onClick={() => navigate("/how-to-use")}
							aria-current={isActive("/how-to-use") ? "page" : undefined}
							className={isShrunk ? "info-button-shrunk" : "info-trigger-button"}
						>
							How to Use
						</button>
					</div>

					<div style={styles.right}>
						<Link
							to="/"
							style={{...styles.link, ...(isActive("/") ? styles.activeLink : {}) }}
						>
							Data
						</Link>

						<Link
							to="/excluded"
							style={{...styles.link, ...(isActive("/excluded") ? styles.activeLink : {}) }}
						>
							Excluded Publications
						</Link>

						<Link
							to="/faq"
							style={{...styles.link, ...(isActive("/faq") ? styles.activeLink : {}) }}
						>
							FAQ
						</Link>

						<Link
							to="/api-reference"
							style={{...styles.link, ...(isActive("/api-reference") ? styles.activeLink : {}) }}
						>
							API
						</Link>

						<Link
							to="/about"
							style={{ ...styles.link, ...(isActive("/about") ? styles.activeLink : {}) }}
						>
							About
						</Link>

						<div style={styles.partnerLogos}>
							<a href="https://ki.se/" target="_blank" style={styles.partnerLogoWrapper}>
								<img src={KILogo} alt="Karolinska Institutet logo" style={styles.partnerLogo} />
							</a>
							<a href="https://www.karolinska.se/" target="_blank" style={styles.partnerLogoWrapper}>
								<img src={KIHLogo} alt="Karolinska Hospital logo" style={styles.partnerLogo} />
							</a>
						</div>
					</div>
				</div>
			</nav>

			{/* so the page content is not hidden behind the fixed navbar*/}
			<div style={{ height: "48px" }} />
		</>
	);
}